module.exports = __webpack_public_path__ + "img/pascal_hugo_boutrais.65f32337.jpg";